const SCHEMA_ERROR_CODES = new Set(['42P01', '42703', 'PGRST204', 'PGRST205'])

const toCombinedErrorText = (error) =>
  [error?.message, error?.details, error?.hint]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

const hasMissingRelationPattern = (text) =>
  /(?:relation|table)\s+["'][^"']+["']\s+does not exist/.test(text) ||
  text.includes('could not find the table') ||
  text.includes('could not find the relation')

const hasMissingColumnPattern = (text) =>
  /column\s+["'][^"']+["']\s+does not exist/.test(text) ||
  text.includes('could not find the column')

export const isSchemaMismatchError = (error) => {
  if (!error) return false

  const code = String(error.code || '').toUpperCase()
  if (SCHEMA_ERROR_CODES.has(code)) return true

  const text = toCombinedErrorText(error)
  return (
    text.includes('schema cache') ||
    hasMissingRelationPattern(text) ||
    hasMissingColumnPattern(text)
  )
}

export const buildSchemaUnavailableMessage = (surfaceLabel, fallbackLabel = '') => {
  const suffix = fallbackLabel ? ` Use ${fallbackLabel} instead.` : ''
  return `${surfaceLabel} tools are unavailable in this environment because required database objects are missing.${suffix}`
}
